<template>
  <div
    @click="changeHightLine()"
  >
    <div class="list-box box-pointer"
         @drop="drop($event)"
         @drag="drag($event)"
         @dragover="dragoverBox($event, 0)"
         @dragleave="dragleaveBox($event,0)"
    >
      <div v-for="(item, index) in taskList" :key="item.task_id + index" class="out_unassigned_list">
        <div class="task-item-box item-focus"
             ref="container"
             :draggable="draggable"
             @dragstart="dragstart($event,item, index)"
             @dragenter="dragenter($event, index)"
             @dragover="dragover($event, index)"
             @dragleave="dragleave($event, index)"
             @click="onclickItem(item,index)"
             @contextmenu.prevent="rightClick($event,item)"
             :class="{ active_task: item.selected }"
        >
          <div v-if="item.type == 'dropoff' || item.type == 'pickup'" class="item-row">
            <div class="task-icon">
              <img v-if="item.type == 'dropoff'" src="@/assets/diapatch/pin.png" alt="">
              <img v-else-if="item.type == 'pickup'" src="@/assets/diapatch/pin(1).png" alt="">
            </div>
            <div class="task-content">
              <div class="title" v-if="item.abs">{{ item.address }}{{ ',&nbsp;' + item.abs }}</div>
              <div class="title" v-else>{{ item.address }}</div>

              <div class="subtitle">
                <img v-if="item.set_urgency == 1" class="task-icon-urgency"
                     src="@/assets/diapatch/rush.png">
                {{ item.invoice_number }}/{{ item.suffix }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    选中后多选的dom-->
    <div v-if="draggedItems.length"
         class="dragging-layer"
         :style="{ top: this.tempY + 'px', left: this.tempX + 'px' }"
    >
      <div v-for="(item, index) in draggedItems"
           :key="item.task_id + index"
           class="drag-item active_task"
      >
        <div v-if="item.type == 'dropoff' || item.type == 'pickup'" class="item-row">
          <div class="task-icon">
            <img v-if="item.type == 'dropoff'" src="@/assets/diapatch/pin.png" alt="">
            <img v-else-if="item.type == 'pickup'" src="@/assets/diapatch/pin(1).png" alt="">
          </div>
          <div class="task-content">
            <div class="title">{{ item.address }}</div>
            <div class="subtitle">
              <img v-if="item.set_urgency == 1" class="task-icon-urgency"
                   src="@/assets/diapatch/rush.png">
              <span>{{ item.invoice_number }}/{{ item.suffix }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store/index";

export default {
  name: 'new-task',
  components: {},
  data() {
    return {
      draggable: true,
      isCtrl: false, // 快捷键 ctrl 是否被按下
      click_tasks: {},
      taskMenu: {
        x: 0,
        y: 0,
        task: null,
        taskType: 'unAssigned'
      },
      info: '',
      draggedItems: [],
      tempX: '',
      tempY: '',
      ctrlKeyActive: false,

      chaOnce: 9999
    }
  },
  computed: {
    taskList() {
      let d = store.state.dis_unassigned_list.data
      if (d) {
        store.state.dis_unassigned_list?.data.forEach(v => {
          v.x = 0
          v.y = 0
        })
      }
      return store.state.dis_unassigned_list.data
    }
  },
  methods: {
    //将所有的高亮都取消
    changeHightLine() {
      // this.ctrlKeyActive = false
    },
    drag(event) {
      // 在拖动过程中，阻止浏览器默认的拖动行为
      event.preventDefault();
      // 更新临时拖动层的位置，使其跟随鼠标移动
      let minLeft = window.outerWidth - (640 - 16)
      let clientX = event.clientX
      let cha = 0
      if (clientX > minLeft) {
        if (this.chaOnce == 9999) {
          cha = clientX - minLeft
          this.chaOnce = cha
        }
      }
      this.tempX = event.clientX - (window.outerWidth - 640 + this.chaOnce) //- 1300
      this.tempY = event.clientY - 100
      this.$forceUpdate()
    },
    rightClick(event, task) {
      let x = event.clientX;
      let y = event.clientY;
      this.$emit('rightClick', x, y, task)
    },
    drop(e) {
      this.tempX = 0
      this.tempY = 0
      this.draggedItems = []
      this.taskList.forEach(v => {
        v.selected = false
      })
      this.$forceUpdate()
      if (e) {
        this.$emit('dropCompleted') //通知父组件当前box已经执行了drop释放操作
        e.currentTarget.style.border = 'none'
      }
      this.$emit('dropStartNewTask', {})//通知父组件当前任务已经开始拖拽
      this.chaOnce = 9999
    },
    dragstart(event, item, index) {
      if (item.selected) {
        this.draggedItems = this.taskList.filter((i) => i.selected).map((i) => ({
          ...i,
          tempX: i.x,
          tempY: i.y,
        }));
      } else {
        this.draggedItems = [{...item, tempX: item.x, tempY: item.y}];
      }
      // 隐藏原始拖动元素
      event.dataTransfer.setDragImage(new Image(), 0, 0);
      event.dataTransfer.setData('application/json', JSON.stringify(this.draggedItems));
      this.$emit('dropStartNewTask', this.draggedItems)//通知父组件当前任务已经开始拖拽
    },
    dragover(e, index) {
      e.preventDefault();
    },
    dragenter(e, index) {
      e.preventDefault();
    },
    dragleave(e, index) {
      e.preventDefault()
    },
    dragoverBox(e) {
      // console.log('--dragoverBox--')
      e.preventDefault();
      e.currentTarget.style.borderBottom = '2px solid #FFFFFF'
    },
    dragleaveBox(e) {
      e.currentTarget.style.border = 'none'
      e.preventDefault()
    },
    dragend() {
      this.tempX = 0
      this.tempY = 0
      this.draggedItems = []
      this.taskList.forEach(v => {
        v.selected = false
      })
      this.$forceUpdate()
    },
    onclickItem(item, index) {
      // console.log(this.ctrlKeyActive,'ctrlKeyActive')
      if (this.ctrlKeyActive) {
        item.selected = !item.selected;
        this.$forceUpdate()
      } else {
        this.taskList.forEach(v => {
          v.selected = false
        })
        this.$forceUpdate()
        item.selected = true;
        this.$emit('findMarker', item.task_id, item)
      }
    },
    handleKeyDown(event) {
      if ((event.ctrlKey) || (event.metaKey)) {
        this.ctrlKeyActive = true;
      }
      // if (event.key === 'Control') {
      // }
    },
    handleKeyUp(event) {
      // console.log(event.ctrlKey)
      this.ctrlKeyActive = false;
    },
    hightUnassignedList(a) {
      this.taskList.forEach(v => {
        if (v.task_id == a.task_id) {
          v.selected = true
        } else {
          v.selected = false
        }
      })
      this.$forceUpdate()
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  },
}
</script>
<style lang="less" scoped>
.list-box {
  min-height: 300px;
  position: relative;
}

.empty {
  color: #FFFFFF;
  padding-top: 50%;
  font-weight: normal;
}

.task-item-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 8px 0;
}

.item-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.task-icon {
  margin-right: 8px;

  img {
    width: 16px;
    height: 16px;
  }
}

.task-content {
  color: white;
  text-align: left;
  font-family: Poppins-Regular, Poppins;
}

.title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.subtitle {
  font-size: 12px;
  color: #CCCCCC;
  font-weight: normal;
  line-height: 20px;
}

.out_unassigned_list:hover div {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  color: #1F2D42 !important;
}

.active_task, .active_task div {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  color: #1F2D42 !important;
}

.item-focus {
  padding-left: 4px;

}

.box-pointer {
  cursor: pointer
}

.selected {
  background-color: red;
}


.dragging-layer {
  position: absolute;
  pointer-events: none; /* 防止拖动层捕获鼠标事件 */
  opacity: 0.8;
  width: 282px;
}

.drag-item {
  user-select: none;
}

</style>
